// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"cX-z","sponsoredTooltipWrapper":"dX-z","sponsoredTooltip":"eX-z","newCard":"fX-z"};